import { render, staticRenderFns } from "./fdle.vue?vue&type=template&id=271c472c&"
import script from "./fdle.vue?vue&type=script&lang=js&"
export * from "./fdle.vue?vue&type=script&lang=js&"
import style0 from "./fdle.vue?vue&type=style&index=0&id=271c472c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports